<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Location</b>
    </sui-card-content>
    <sui-card-content>
      <Flag :country="regionData.country" v-if="regionData.country" />
      <i class="map marker alternate inverted circular big grey icon" v-if="!regionData.country" />
      <b v-if="regionData.country">{{regionData.city}}</b>
      <b v-if="!regionData.country">Unknown</b>
    </sui-card-content>
  </sui-card>
</template>

<script>
  export default {
    name: 'HostLocationCard',
    props: {
      host: {
        type: Object,
        required: true,
      },
    },
    computed: {
      regionData() {
        return this.host._regionData
      },
    },
  }
</script>

<style scoped>
  .content:nth-child(2) { flex-grow: 1!important; justify-content: space-around!important; }
  .flag-icon { font-size: 4em; background-size: 100%; border-radius: .1em; }
</style>
